<template>
    <div class="">
      <!-- Card Fondos -->
      <div
        class="b-card b-card--shadow-small b-card--hover pointer"
        :class="{ 'demo-locked-cursor': isLockedList }"
        @click.capture="demoLockGuard"
        @click="open()"
      >
        <div class="card-fondo">
          <div class="card-fondo__content">
            <div class="card-fondo__ico">
              <div class="ico-box ico-box--45">
                <img :src="$fundIcons[fund.fundTypeId]" alt="Tipo de fondo" />
              </div>
            </div>
            <div class="card-fondo__title" v-text="fund.title"></div>
          </div>
          <div class="card-fondo__actions">
            <span class="card-fondo__link">{{ $t("guest.funds.contribute") }}</span>
          </div>
        </div>
      </div>
      <!-- Modal box -->
      <FluxFondosClassic
        :key="fund.id"
        :show="showModal"
        :fund="fund"
        :list="list"
        @close="close()"
        @finish="finish()"
      ></FluxFondosClassic>
  
      <transition name="bbFade" @after-enter="showSuccessModalContent = true">
        <div class="modal" v-show="showSuccessModal" @click="showContent = false">
          <transition name="bbUp" @after-leave="closeShowSuccessModal()">
            <div
              class="modal__card modal__card--mini"
              v-show="showSuccessModalContent"
              @click.stop=""
            >
              <div class="modal__dialog">
                <div class="modal__header">
                  <div class="modal__close">
                    <img
                      src="../../../assets/img/ico/ico-close.svg"
                      alt="Cerrar"
                      @click="showSuccessModalContent = false"
                    />
                  </div>
                </div>
                <div class="modal__content">
                  <div class="card-success">
                    <div class="card-success__ico">
                      <img
                        src="../../../assets/img/ico/ico-color-success.svg"
                        alt="¡Gracias!"
                      />
                    </div>
                    <h3 class="card-success__header">{{ $t("guest.funds.done") }}</h3>
                    <div class="card-success__content">
                      {{ $t("guest.funds.emailSent", {x: list.ownerName}) }}
                    </div>
                    <div class="card-success__actions">
                      <a
                        href="#"
                        @click="showSuccessModalContent = false"
                        class="button button--primary button--w60"
                        >{{ $t("guest.funds.ok") }}</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </transition>
      <modal-dialog
        :show="showWarningModal"
        @close="showWarningModal = false"
        target-class="modal__card--mini"
      >
      <div class="card-success">
        <div class="card-success__ico mar-t-0">
          <img src="../../../assets/img/ico/ico-round-fondos-success.svg" alt="" />
        </div>
        <h3 class="card-success__header">{{ $t("guest.funds.notPossible") }}</h3>

        <div class="card-success__content mar-b-0">
          {{ $t("guest.funds.piggybankNotEnabled", { name: list.ownerName }) }}
        </div>
      </div>
    </modal-dialog>
    </div>
  </template>
  <script>
  import FluxFondosClassic from "../components/FluxFondosClassic.vue";
  import ModalDialog from "../../../components/ui/ModalDialog";
  import DemoLockable from "./mixins/DemoLockable.vue";

  export default {
    name: "ListFondosCardClassic",
    components: {
      FluxFondosClassic,
      ModalDialog,
    },
    mixins: [DemoLockable],
    props: {
      fund: {
        type: Object,
        required: true,
      },
      list: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        showModal: false,
        showSuccessModal: false,
        showSuccessModalContent: false,
        showWarningModal: false,
      };
    },
    methods: {
      closeShowSuccessModal() {
        this.showSuccessModal = false;
        document.body.classList.remove("modal-open");
      },
      open() {
        if (this.list.contributionMethods.length === 0) {
          this.showWarningModal = true;
          return;
        }
        this.showModal = true;
        document.body.classList.add("modal-open");
      },
      close() {
        this.showModal = false;
        document.body.classList.remove("modal-open");
      },
      finish() {
        this.close();
        document.body.classList.add("modal-open");
        this.showSuccessModal = true;
      },
    },
    beforeMount() {
      const escapeHandler = (e) => {
        if (e.key === "Escape") {
          this.showSuccessModalContent = false;
        }
      };
      document.addEventListener("keydown", escapeHandler);
      this.$once("hook:destroyed", () => {
        document.removeEventListener("keydown", escapeHandler);
      });
    },
  };
  </script>
  
  <style>
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  
  .fade-enter-active,
  .fade-leave-active {
    transition: 0.2s opacity ease-out;
  }
  </style>
  